import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/testimonials";

export const Testimonials = ({ serviceSlug }) => {
  const items = TESTIMONIALS.filter((t) => !serviceSlug || t.service === serviceSlug);
  if (items.length === 0) return null;
  return (
    <section data-testid="testimonials-section" className="my-12">
      <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-white font-heading mb-6">What Our Clients Say</h2>
      <div className="grid sm:grid-cols-2 gap-5 max-w-5xl">
        {items.map((t, i) => (
          <figure key={i} data-testid={`testimonial-${i}`} className="rounded-2xl border border-amber-500/20 bg-slate-900/60 p-6">
            <Quote className="h-6 w-6 text-amber-400 mb-3" />
            <blockquote className="text-sm text-slate-200 leading-relaxed mb-4">"{t.quote}"</blockquote>
            <figcaption className="text-xs font-semibold text-amber-400">
              {t.author} <span className="text-slate-500 font-normal">— {t.org}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
